var React = require('react');

function Hamburger (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M224,128a8,8,0,0,1-8,8H40a8,8,0,0,1,0-16H216A8,8,0,0,1,224,128ZM40,72H216a8,8,0,0,0,0-16H40a8,8,0,0,0,0,16ZM216,184H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z"}));
}

Hamburger.defaultProps = {"width":"24","height":"24","fill":"white","viewBox":"0 0 256 256"};

module.exports = Hamburger;

Hamburger.default = Hamburger;
